import { render, staticRenderFns } from "./ProductCardTop.vue?vue&type=template&id=492456c6&scoped=true&"
import script from "./ProductCardTop.vue?vue&type=script&lang=js&"
export * from "./ProductCardTop.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardTop.vue?vue&type=style&index=0&id=492456c6&prod&lang=scss&scoped=true&"
import style1 from "./ProductCardTop.vue?vue&type=style&index=1&id=492456c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492456c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageProduct: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ImageProduct.vue').default})
